import { BaseDialog } from "@/shared/components/dialog/base-dialog";

interface Props {
  isShow: boolean;
  title: string;
  leftAreaOnTap: () => void;
  leftAreaText: string;
  rightAreaOnTap: () => void;
  rightAreaText: string;
  isRightButtonRed?: boolean;
  children?: JSX.Element;
  outAreaOnTap?: () => void;
}

export const SelectConfirmDialog = (props: Props) => {
  const {
    isShow,
    title,
    leftAreaOnTap,
    leftAreaText,
    rightAreaOnTap,
    rightAreaText,
    isRightButtonRed = false,
    children,
    outAreaOnTap,
  } = props;

  const rightButtonRedClass = isRightButtonRed
    ? " select-dialog__right-color-red"
    : "";

  const showLeftButton = leftAreaText.trim() !== "";

  return (
    <BaseDialog
      isShow={isShow}
      title={<p className="select-dialog__header">{title}</p>}
      leftButton={
        showLeftButton ? (
          <button className="select-dialog__button" onClick={leftAreaOnTap}>
            {leftAreaText}
          </button>
        ) : undefined
      }
      rightButton={
        <button
          className={"select-dialog__button" + rightButtonRedClass}
          onClick={rightAreaOnTap}
        >
          {rightAreaText}
        </button>
      }
      outAreaOnTap={outAreaOnTap}
    >
      {children}
    </BaseDialog>
  );
};

export default SelectConfirmDialog;
